import {
  ArrayLoading,
  ManufacturingSeries as BaseManufacturingSeries,
  ProductClass as BaseProductClass,
  Category,
  ResponseArray,
} from '@/store/types'

export default interface State {
  product: Product
  images: Image[]
  Error: boolean
  sideBarModel: SideBarItem
  showPrintView: boolean
  activeSection: Section
  activeSectionTab: SectionTab
  activeImage: Image
}

export interface Product {
  CategoryId: number
  ProductClassId: number
  ManufacturingSeriesId: number
  ProductId: number
  DisplayName: string
  Description: string
  Name: string
  ManufacturingSeries?: ManufacturingSeries
  Specifications?: string[]
  Features?: string[]
  Notes?: string[]
  Images: Image[]
  Sections: ArrayLoading<Section>
  loading: boolean
}

export interface ManufacturingSeries extends BaseManufacturingSeries {
  CategoryId: number
  ProductClassId: number
  TpiMfgSeries: string
  ProductClass: ProductClass
}

export interface Image {
  ImageId: number
  Path: string
  Caption: string
  ImagePath: string
  loading: boolean
}

export interface ProductClass extends BaseProductClass {
  CategoryId: number
  Category: Category
}

// because we can't extend and add nothing to it.
export type { Category } from '@/store/types'
// export interface Category extends BaseCategory {
// }

export interface Section {
  SectionId: number
  Name: string
  DisplayName: string
  MobileDisplayName: string
  Tabs: SectionTab[]
  active: boolean
}

export interface SectionTab {
  SectionTabId: number
  Name: string
  DisplayName: string
  MobileDisplayName: string
  OrderBy: number
  Items: SectionItem[]
  active: boolean
}

export interface SectionItem {
  DisplayName: string
  SectionItemType: string
  Cols: number
  key: string
}

export interface SectionTable extends SectionItem {
  SectionTableId: number
  TableLayout: TableLayout
  HideBlankColumns: boolean
  DetailsPanel: boolean
  HideTableFilters: boolean
  Models: ArrayLoading<Model>
  filteredModels: Model[]
  sorts: TableLayoutColumn[]
  loading: boolean
  fields: any // Why doesn't this work anymore? ({ key: string } & BvTableField)[]
  keyword: string
  HasCart: boolean
  isNone: boolean
  ShowInventory: boolean
  IsMultipliable: boolean
}

export interface SectionParts extends SectionItem {
  SectionPartsId: number
}

export interface SectionList extends SectionItem {
  SectionListId: number
  PropertyName: string
  OrderBy: number
  Items: ProductListItem[]
}

export interface ProductListItem {
  ProductListItemId: number
  Text: string
}

export interface SectionImage extends SectionItem, Image {
  SectionImageId: number
  ImageId: number
  Caption: string
  OriginalWidth: number
  OriginalHeight: number
  ExplodedView: boolean
  Path: string
  ImagePath: string
  Width: number
  Height: number
  OrderBy: number
  AltText: string
  IsThumbnail: boolean

}

export interface SectionRichText extends SectionItem {
  SectionRichTextId: number
  RichText: string
}

export interface SectionSpinSirv extends SectionItem {
  SectionSpinSirvId: number
  Url: string
}

export interface TableLayout {
  SectionTableLayoutId: number
  DisplayName: string
  Columns: TableLayoutColumn[]
  isNone: boolean
}

export interface ILayoutColumn {
  EntityName: string
  EntityPropertyName: string
  PropertyName: string
  ParentPropertyName: string
  PropertyType: string
  ParentPropertyType: string
  // TableName: string
  // ColumnName: string
  DisplayName: string
  OverrideProperty: string | null
  FormatType?: string
  FormatValue?: string
  ParentFormatType?: string
  ParentFormatValue?: string
  key: string
  OrderBy: number;
}

// TODO: a lot of these values I'm adding will come from the server side as a state of sorts
export interface TableLayoutColumn extends ILayoutColumn {
  SectionTableLayoutColumnId: number
  EntityName: string
  EntityPropertyName: string
  // ParentEntityName: string
  // ParentEntityPropertyName: string
  Name: string
  DisplayDescription: string
  SortBy: boolean
  FilterBy: boolean
  KeywordSearchBy: boolean
  ShowOnMobile: boolean
  facets: Facet[]
  sort: number
  keyword: string
  filterVisible: boolean
  filteredModels: Model[]
  isCustom?: boolean
}

export interface Facet {
  name: string
  displayName: string
  count: number
  selected: boolean
  key: string
}

export interface Fields {
  key: string
  thClass: string
}

export interface ModelDetails {
  key: string
  value: string
}

export interface ResponseArrayModel extends ResponseArray<Model> {
  Table: SectionTable
}

export interface Model {
  PcnCatalogNumber: string
  ImportFileId: number
  EntityType: string
  MigrationDetails: string
  FingoodTpiMfgMod: string
  TotalList: string
  SapModelDescription: string
  ProductHierarchy: string
  ModelDescriptions?: string[]
  ModelDimensions?: ModelDimensions[]
  ModelNotes?: string[]
  ModelProductClassTypes?: ModelProductClassTypes[]
  Details: { [key: string]: object }
  [key: string]: any
  isNone: boolean
  formattedValue: { [key: string]: string }
  CustomerMaterialNumber: string
}

export interface ModelDimensions {
  DiagramRow: number
  DiagramColumn: string
  Dimension: string
}

export interface ModelProductClassTypes {
  ProductClassTypeId: string
  ProductClassType: ProductClassTypes
}

export interface ProductClassTypes {
  ProductClassType1: string
}

export interface Table {
  Column: string
  Value: object
}

export interface ModelNone {
  PcnCatalogNumber: string
  isNone: true
}

export interface TableLayoutNone {
  SectionTableLayoutId: number
  isNone: true
}

export interface SectionTableNone {
  DisplayName: string
  isNone: true
}

export interface SideBarItem {
  visible: boolean
  model: Model | ModelNone
  tableLayout: TableLayout | TableLayoutNone
  sectionTable: SectionTable | SectionTableNone
}

export enum MultiplierPricingType {
  NetPrice = 1,
  Multiplier = 2,
}
